<div class="platform-container" id="how-it-works">
  <div class="platform-content">
    <div class="platform-section">
      <span class="emphasis section-header">
        {{ 'mainPageComponent.paltformBanner.howItWorks' | translate }}
      </span>
      <h2 class="title-md">
        {{ 'mainPageComponent.paltformBanner.header' | translate }}
      </h2>
      <span class="subtitle-md platform-text">
        {{ 'mainPageComponent.paltformBanner.bannerText' | translate }}
      </span>
    </div>
    <app-stepper />
  </div>
</div>
